var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.917,
    height: 13.299,
    viewBox: "0 0 15.917 13.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#1d0e3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.875 -3.826)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.167,26.5V25.167A2.667,2.667,0,0,0,9.5,22.5H4.167A2.667,2.667,0,0,0,1.5,25.167V26.5",
    transform: "translate(0 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.833,7.167A2.667,2.667,0,1,1,10.167,4.5a2.667,2.667,0,0,1,2.667,2.667Z",
    transform: "translate(-3.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32,26.608V25.275a2.667,2.667,0,0,0-2-2.58",
    transform: "translate(-15.833 -10.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,4.7a2.667,2.667,0,0,1,0,5.167",
    transform: "translate(-12.5 -0.108)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherUsers);
export default __webpack_public_path__ + "static/media/feather-users.18d0432c1823fda00baa92c9f44a98ea.svg";
export { ForwardRef as ReactComponent };